import { render, staticRenderFns } from "./InsurancePatient.vue?vue&type=template&id=d17c63d6"
import script from "./InsurancePatient.vue?vue&type=script&lang=js"
export * from "./InsurancePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports